/**
 * Normalized OS consts
 */
export let OSName = /*#__PURE__*/function (OSName) {
  OSName["Win"] = "Win";
  OSName["Mac"] = "Mac";
  OSName["Linux"] = "Linux";
  OSName["Android"] = "Android";
  OSName["iOS"] = "iOS";
  OSName["Unknown"] = "Unknown";
  return OSName;
}({});

/**
 * Return normalized os name from user agent string
 */
export function parseOSName(platform) {
  /* eslint-disable @sas/i18n/jsx-to-localize */
  if (platform.indexOf('Win') === 0) return OSName.Win;
  if (platform.indexOf('Mac') === 0) return OSName.Mac;
  if (platform.indexOf('Linux') === 0) return OSName.Linux;
  if (platform.indexOf('Android') === 0) return OSName.Android;
  /* eslint-enable @sas/i18n/jsx-to-localize */
  if (/iPhone|iPad|iPod/.test(platform)) return OSName.iOS;
  return OSName.Unknown;
}
let _OSName = null;
/**
 * Returns current normalized OS
 */
export function getOSName() {
  if (_OSName === null) {
    _OSName = parseOSName(window.navigator.platform);
  }
  return _OSName;
}
//# sourceMappingURL=os-name.js.map